import { render, staticRenderFns } from "./contactCustomer.vue?vue&type=template&id=16e54f65&"
import script from "./contactCustomer.vue?vue&type=script&lang=js&"
export * from "./contactCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports